import React, { useState, useEffect } from 'react';
import {
    UserProjectionCardContainer,
    Select,
    Form,
    FormInput,
    FilterWrap,
    SelectButton,
    FormH1,
    UserProjectionContainer
} from './CrewBuilderElements'
import UserProjectionCardDeck from './UserProjectionCardDeck';

const UserProjectionDisplay = ({ assetList, handleNext, handlePrevious, handleSubmit, hidden, currentCard }) => {

    const [listStatus, setListStatus] = useState(false);

    useEffect(() => { if (assetList && assetList.assets) { setListStatus(true) } }, [assetList])

    return (
        <div>
            {listStatus ? (
                <UserProjectionContainer lightBg={true} >
                    <FormH1>Select Your Projections</FormH1>
                    {/* <FilterWrap>
                        <Form>
                            <FormInput
                                className='projection-input'
                                type='text'
                                onChange={handleChange}
                                placeholder='Search'
                            />
                        </Form>
                        <NextButton onClick={handleClick} dark={true}> Show Next </NextButton>
                        <Select onChange={handleCategoryChange}>
                            <option value="" hidden>
                                Platform (All)
                            </option>
                            <option value="DraftKings">Draft Kings</option>
                            <option value="FanDuel">Fan Duel</option>
                        </Select>
                    </FilterWrap> */}
                    <UserProjectionCardContainer singleProjection={true}>
                        <UserProjectionCardDeck players={assetList.assets.slice(0, 1)} handleNext={handleNext} handlePrevious={handlePrevious} currentCard={assetList.assets[currentCard].playerID} />
                    </UserProjectionCardContainer>
                    {hidden ? (<></>) : <SelectButton onClick={handleSubmit}> Submit </SelectButton>}
                </UserProjectionContainer>
            ) :
                <UserProjectionContainer></UserProjectionContainer>

            }
        </div>
    )
};

export default UserProjectionDisplay;